













































import Vue from 'vue';
import { Registry } from '../runtime/Registry';
import { TypeSubNode } from '../runtime/types/TypeVisuals';


export default Vue.extend({
  name: 'debug-node',
  props: {
    node: {
      type: Object as () => TypeSubNode,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    groupSize: {
      type: Number,
      default: 10,
    },
  },
  data: () => ({
    open: false,
    subString: '?',
    subsGroups: [] as TypeSubNode[][],
  }),
  computed: {
    subs(): TypeSubNode[] {
      return this.registry.getTypeSubNodes(this.node.value, this.node.valueType);
    },
    hasMore(): boolean {
      return this.subsGroups.length * this.groupSize < this.subs.length;
    },
    hasSubs(): boolean {
      return this.subs.length > 0;
    },
    valueTypeName(): string {
      return this.registry.getTypeName(this.node.valueType);
    },
  },
  watch: {
    subs: {
      immediate: true,
      handler(subs: TypeSubNode[]) {
        const size = this.groupSize;
        const totalVisible = Math.max(this.groupSize, this.subsGroups.reduce((total, g) => total + g.length, 0));

        const subsGroups: TypeSubNode[][] = [];
        let offset = 0;
        while (offset < totalVisible) {
          subsGroups.push(subs.slice(offset, offset + size));
          offset += size;
        }

        this.subsGroups = subsGroups;
      },
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    addMore() {
      const count = this.subsGroups.length;
      const size = this.groupSize;
      const offset = count * size;

      this.subsGroups.push(this.subs.slice(offset, offset + size));
    },
  },
});
